import gql from 'graphql-tag';

export default gql`
mutation($isPreviewWindowOpen: Boolean!) {
  setPreviewWindow(isPreviewWindowOpen: $isPreviewWindowOpen) @client
}
`;
